import { Box } from "@mui/material";
import React, { useEffect } from "react";
import Sidebar from "../../components/SidebarLayout/Sidebar";
import ViewDefectDetailsContent from "../../components/Defects/DefectDetails/ViewDefectDetailsContent";
const ViewDefectDetails = () => {
  return (
    <>
      <Sidebar activeTab="Defects" title="Defects">
        <Box className="globalContainer_For_Content">
          <ViewDefectDetailsContent />
        </Box>
      </Sidebar>
    </>
  );
};

export default ViewDefectDetails;
